import React from 'react';
import styled from 'styled-components';


const LogoText = styled.text`
    font-size: 36px;
    font-weight: 600;
    line-height: 54px;

    @media (max-width: 1050px) {
        font-size: 26px;
    }

    @media (max-width: 992px) {
        display: none;
    }
`;

const LogoImage = styled.img`
    fill: rgba(70, 70, 70, 1);
    transform: translateY(16px);
`;

const LogoDiv = styled.div`
    color: rgba(70, 70, 70, 1);
`;

const Logo = (props) => {
    return (
        <LogoDiv>
            <LogoImage alt='Shift Planner Logo' src="ant-design_schedule-outlined.svg" /><LogoText>Shift Planner</LogoText>
        </LogoDiv>
    );
}

export default Logo;